module.exports = "pegasus_template/assets/theme2/large/1.jpg";